<ion-content>
  <div class="box-body">
    <div class="localidade micro-size" *ngIf="tamanho === 'P'">
      <img [src]="'assets/imgs/widgets/local.svg'" alt=""/>
      <p class="descricao">{{ estacao.municipio.noMunicipio }} - {{ estacao.municipio.sgUf }}</p>
    </div>
    <div class="inner-qualidade">
      <div class="iqar-box" [ngClass]="{'default-size' : ['M', 'G'].includes(tamanho), 'micro-size' : tamanho === 'P'}">
        <p>
          <strong [ngClass]="getQualidadeClass(getNoClassificacao(estacao))">
            {{ (getMedicao(estacao) | iqar:estacao?.indiceQualidadeArAtual?.medicao) || " - " }}
          </strong>
        </p>
        <p class="iqar-text">IQAr</p>
        <div class="quality-indicator" [ngClass]="getQualidadeClass(getNoClassificacao(estacao))">
        </div>
      </div>

      <div class="info-container">
        <p class="name" *ngIf="['M', 'G'].includes(tamanho)">{{ estacao?.noEstacao }}</p>
        <div class="localidade" *ngIf="['M', 'G'].includes(tamanho)">
          <img [src]="'assets/imgs/widgets/local.svg'" alt=""/>
          <p class="descricao">{{ estacao.municipio.noMunicipio }} - {{ estacao.municipio.sgUf }}</p>
        </div>
        <p class="qualidade-text">Qualidade do ar</p>
        <p class="qualidade-ar" [ngClass]="getQualidadeClass(getNoClassificacao(estacao))">
          {{ getNoClassificacao(estacao) || " - " }}
        </p>
        <p class="dt-atualizacao" *ngIf="['M', 'G'].includes(tamanho)">
          Atualizado em  {{ getDtUltimaAtualizacaoFormated(estacao.dtUltimaAtualizacao) }}
        </p>
      </div>
    </div>
  </div>
</ion-content>
